export function isRunningInNativeApp() {
  return typeof window.isNativeApp !== "undefined" && window.isNativeApp;
}

export function isMobile() {
  return window.innerWidth <= 768;
}
